// extracted by mini-css-extract-plugin
export default {"icon":"XDMMJ","text":"RBTZI","button":"_5uA6w","textButton":"zlNtz","iconButton":"VTEm-","animated":"NG0KU","verticalAlign":"dmP1r"};